import cn from 'classnames';
import { memo, useEffect, useState } from 'react';
import { ArrowDown } from '@shared/assets/index';
import { DropdownItem, DropdownMenu, useMenuDropdown } from '@shared/ui/index';
import { TextInputM, type TextInputMPT } from '@shared/ui/inputs/TextInputM/ui';
import type { MenuProps } from '@shared/ui/menus/dropdown-menu/ui';
import st from './styles.module.scss';

export type SelectPT = Omit<TextInputMPT, 'defaultValue' | 'onChange'> &
  Partial<Omit<MenuProps, 'children' | 'additionalChildren'>> & {
    defaultValue?: boolean;
    values?: Array<{ forUser: string; value: string }>;
    onChange?: (value: string) => void;
    initValue?: string;
    isClicable?: boolean;
  };

export const Select = memo(
  ({
    error,
    // className,
    defaultValue,
    values,
    onChange,
    children,
    isMenuOpen: isMenuOpenFromProps,
    menuRef: menuRefFromProps,
    wrapperClassName,
    dropDownClassName,
    initValue,
    isClicable = true,
    ...props
  }: SelectPT) => {
    const {
      menuRef,
      handleAction,
      handleToggleDropdown,
      isMenuOpen: isMenuOpenFromHook,
    } = useMenuDropdown({});

    const [value, setValue] = useState(
      initValue || (defaultValue && values ? values[0].value : '')
    );

    const [forUser, setForUser] = useState(() => {
      if (values && value) {
        const lookedValueIndex = values.findIndex((el) => el.value === value);
        if (~lookedValueIndex) {
          return values[lookedValueIndex].forUser;
        }
      }
      return '';
    });

    useEffect(() => {
      onChange && onChange(value);
    }, [value, onChange]);

    const isMenuOpen = isMenuOpenFromProps || isMenuOpenFromHook;

    return (
      <DropdownMenu
        wrapperClassName={cn(st.dropDownWrapper, props.fullWidth && st.fullWidth, wrapperClassName)}
        dropDownClassName={cn(st.dropDown, dropDownClassName)}
        isMenuOpen={isMenuOpen}
        menuRef={menuRefFromProps || menuRef}
        additionalChildren={
          <TextInputM
            inputClassName={cn(
              isMenuOpen ? st.open : props.inputClassName,
              isClicable && st.clicable
            )}
            value={forUser}
            readOnly
            error={error}
            onClick={values && handleToggleDropdown}
            suffix={<ArrowDown className={isMenuOpen ? st.arrowUp : undefined} />}
            {...props}
          />
        }
      >
        {values &&
          values.map((el) => (
            <DropdownItem
              className={st.item}
              key={el.value}
              onClick={handleAction(() => {
                setValue(el.value);
                setForUser(el.forUser);
              })}
            >
              {el.forUser}
            </DropdownItem>
          ))}

        {children}
      </DropdownMenu>
    );
  }
);
